export default "__VITE_ASSET__BgO_Y74L__"